export const exampleTasks = [
  { id: 1, content: "Nauczyć się Reacta", done: false },
  { id: 2, content: "Przeczytać dokumentację Redux", done: false },
  { id: 3, content: "Nauczyć się Redux", done: false },
  { id: 4, content: "Oddać projekt", done: false },
];
